import { styled } from '@mui/material';

export const StyledTitle = styled('div')(() => ({
  fontWeight: 700,
  fontSize: 17,
  paddingLeft: '18px',
  marginTop: '10px',
}));

export const SelectedInternsTitle = styled('div')(() => ({
  fontWeight: 700,
  fontSize: 17,
}));
